// src/components/PostMioLogo.jsx
// Usage: <PostMioLogo size="md" variant="dark" />
// size:    "sm" | "md" | "lg"
// variant: "dark"  → cream text on dark bg (default)
//          "light" → dark text on light bg

export default function PostMioLogo({ size = "md", variant = "dark", className = "" }) {
  const cfg = {
    sm: { h: 26,  iw: 22,  gap: 8,  fs: 18 },
    md: { h: 34,  iw: 30,  gap: 10, fs: 26 },
    lg: { h: 48,  iw: 42,  gap: 13, fs: 36 },
  }
  const c   = cfg[size] || cfg.md
  // 4.5 multiplier gives generous right padding — never clips the final "o"
  const tw  = c.iw + c.gap + c.fs * 4.5
  const txt = variant === "dark" ? "#F0EDE8" : "#1A1108"

  return (
    <svg
      className={className}
      height={c.h}
      viewBox={`0 0 ${tw} ${c.h}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "inline-block", verticalAlign: "middle", flexShrink: 0 }}
    >
      {/* Bubble body */}
      <rect x="0" y="0" width={c.iw} height={c.iw * 0.78} rx={c.iw * 0.28} fill="#C9922A" />
      {/* Tail */}
      <polygon
        points={`${c.iw*0.08},${c.iw*0.76} ${c.iw*0.34},${c.iw*0.76} ${c.iw*0.18},${c.iw*1.00}`}
        fill="#C9922A"
      />
      {/* 3 dots */}
      {[-0.22, 0, 0.22].map((o, i) => (
        <circle key={i} cx={c.iw*0.5 + c.iw*o} cy={c.iw*0.39} r={c.iw*0.075} fill="#0A0A0A" />
      ))}
      {/* Wordmark */}
      <text
        x={c.iw + c.gap}
        y={c.h * 0.82}
        fontFamily="'Lora', 'Georgia', serif"
        fontWeight="700"
        fontSize={c.fs}
        letterSpacing="-0.5"
      >
        <tspan fill={txt}>Post</tspan>
        <tspan fill="#C9922A">Mio</tspan>
      </text>
    </svg>
  )
}
